var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"textarea",class:{ 'textarea--design-new': _vm.design === 'new', 'textarea--error': _vm.error },domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value || null)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }